import { gql } from '@apollo/client'
import { InputMaybe, Scalars } from '../../../../client/graphql'

export type QuerySearchTariffsSalesArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>,
	page?: InputMaybe<Scalars['Int']['input']>
}

export const searchTariffsSalesGql = gql`
	query searchTariffs($limit: Int, $page: Int) {
		searchTariffs(limit: $limit, page: $page) {
			list {
				_id
				clientId
				code
				translation {
					lang
					name
				}
				createdAt
				updatedAt
			}
		}
	}
`
